import {SUCCESS} from "../../../../constants/action-postfix";
import {GRADUATES_DETAILS_REQUEST} from "../summGraduatesHEOReducer";


const initialState = []


export const summGraduatesHEODetailsReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${GRADUATES_DETAILS_REQUEST}${SUCCESS}`:
            return action.payload;

        default:
            return state;
    }
};
